const { SITE_SECTION, ENABLE_TRACKING, PAGE_TRACKING } = require("./trackingConstants");

const getAdpProperties = (pageInformation, pageType, pageLang) => {
  const title = `${pageInformation.person_name} -${pageInformation &&
    pageInformation.address &&
    pageInformation.address.city}, ${pageInformation &&
    pageInformation.address &&
    pageInformation.address.state_code} - Real Estate Agent - realtor.com®`;
  let dynamicModules = "";
  if (pageInformation.designations && pageInformation.designations.length > 0) {
    dynamicModules = pageInformation.designations
      .map((desig) => desig.name.toLowerCase())
      .join("|");
  }
  let properties = null;
  if (pageInformation) {
    properties = {
      pageType: pageType,
      pageId: pageType,
      siteSection: SITE_SECTION,
      pageLang: pageLang,
      pageTitle: title,
      title,
      rdcTrackingEnabled: ENABLE_TRACKING.YES,
      advertiserId: pageInformation.advertiser_id + "",
      dynamicModules: dynamicModules,
      dynamicElements: "",
    };
  }
  return properties;
};

const getLandingPageProperties = (pageName, abTestIdListValues) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    rdcTrackingEnabled: ENABLE_TRACKING.YES,
    abTestIdList: abTestIdListValues,
  };
  return properties;
};

const getRecommModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.RECOMM_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.RECOMM_MODAL_NAME,
  };
  return properties;
};
const getRatingModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.RATING_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.RATING_MODAL_NAME,
  };
  return properties;
};
const getAskQuestionModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.ASK_QUESTION_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.ASK_QUESTION_MODAL_NAME,
  };
  return properties;
};

const getBannerFormModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.BANNER_FORM_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.BANNER_FORM_MODAL_NAME,
  };
  return properties;
};

const getContactAgentModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.CONTACT_AGENT_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.CONTACT_AGENT_MODAL_NAME,
  };
  return properties;
};

const getFindAnAgentModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.FIND_AN_AGENT_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.FIND_AN_AGENT_MODAL_NAME,
  };
  return properties;
};

const getShareModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.SHARE_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.SHARE_MODAL_NAME,
  };
  return properties;
};

const getAgentRecommendationModalProperties = (pageName, withLexAgent) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.AGENT_RECOMMENDATION_MODAL_TRIGGER,
    modalName: withLexAgent
      ? PAGE_TRACKING.ADP_MODAL.AGENT_RECOMMENDATION_MODAL_NAME
      : PAGE_TRACKING.ADP_MODAL.WITHOUT_AGENT_RECOMMENDATION_MODAL_NAME,
  };
  return properties;
};

const getAgentHelpModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.AGENT_HELP_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.AGENT_HELP_MODAL_NAME,
  };
  return properties;
};

const getAgentHelpRecommendationModalProperties = (pageName) => {
  const properties = {
    pageName: pageName,
    siteSection: SITE_SECTION,
    modalTrigger: PAGE_TRACKING.ADP_MODAL.AGENT_HELP_RECOMMENDATION_MODAL_TRIGGER,
    modalName: PAGE_TRACKING.ADP_MODAL.AGENT_HELP_RECOMMENDATION_MODAL_NAME,
  };
  return properties;
};

module.exports = {
  getAdpProperties,
  getRecommModalProperties,
  getAskQuestionModalProperties,
  getShareModalProperties,
  getRatingModalProperties,
  getBannerFormModalProperties,
  getContactAgentModalProperties,
  getFindAnAgentModalProperties,
  getLandingPageProperties,
  getAgentRecommendationModalProperties,
  getAgentHelpModalProperties,
  getAgentHelpRecommendationModalProperties,
};
